






















import { defineComponent, onMounted, PropType, ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

interface SelectOption {
  value: any
  text: string
  disabled?: boolean
}

export default defineComponent({
  inheritAttrs: false,
  components: {
    vSelect,
  },
  props: {
    value: {
      required: false,
      default: null,
    },
    options: {
      type: Array as PropType<SelectOption[]>,
      required: true,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: true,
    },
    placeholder: {
      type: String as PropType<string>,
      required: false,
      default: "-",
    },
  },
  setup(props, context) {
    const selectRef = ref<any>(null);
    const controlWidth = ref<string>("120px");

    // 全候補の表示幅を計測し、最も長い候補に操作領域を加えた横幅へ揃える
    const calculateControlWidth = (): void => {
      context.root.$nextTick(() => {
        const selectElement = selectRef.value ? selectRef.value.$el as HTMLElement : null;
        if(!selectElement){
          return;
        }

        const canvas = document.createElement("canvas");
        const canvasContext = canvas.getContext("2d");
        if(!canvasContext){
          return;
        }

        const computedStyle = window.getComputedStyle(selectElement);
        canvasContext.font = computedStyle.font || `${computedStyle.fontSize} ${computedStyle.fontFamily}`;

        const maxTextWidth = props.options.reduce((maxWidth, option) => {
          return Math.max(maxWidth, canvasContext.measureText(String(option.text || "")).width);
        }, 0);

        // 選択解除・開閉アイコンと左右余白の表示領域を確保する
        controlWidth.value = `${Math.max(120, Math.ceil(maxTextWidth + 72))}px`;
      });
    };

    onMounted(calculateControlWidth);
    watch(() => props.options, calculateControlWidth, {deep: true});

    // 既存のプルダウンと同様に、選択肢オブジェクトではなくコード値を画面へ返す
    const getOptionValue = (option: SelectOption): any => option.value;

    // disabledが指定されたマスタは候補に表示したまま選択不可にする
    const isSelectable = (option: SelectOption): boolean => !option.disabled;

    // 表示名とコードのどちらでも大文字・小文字を区別せず部分一致で絞り込む
    const filterBy = (option: SelectOption, label: string, search: string): boolean => {
      const keyword = search.trim().toLocaleLowerCase();
      const optionLabel = String(label || "").toLocaleLowerCase();
      const optionValue = String(option.value == null ? "" : option.value).toLocaleLowerCase();
      return optionLabel.includes(keyword) || optionValue.includes(keyword);
    };

    // v-modelと既存のchangeイベントの両方へ選択値を通知する
    const onInput = (selectedValue: any): void => {
      context.emit("input", selectedValue);
      context.emit("change", selectedValue);

      // 候補選択後に検索入力欄のフォーカスを外し、実在しない空白のようなカーソル表示を防ぐ
      context.root.$nextTick(() => {
        const selectElement = selectRef.value ? selectRef.value.$el as HTMLElement : null;
        const searchInput = selectElement ? selectElement.querySelector("input.vs__search") as HTMLInputElement : null;
        if(searchInput){
          searchInput.blur();
        }
      });
    };

    return {
      selectRef,
      controlWidth,
      getOptionValue,
      isSelectable,
      filterBy,
      onInput,
    };
  },
});
